import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import BreakEditCron from "@/components/break/edit/BreakEditCron.vue";
import moduleBreaks from "@/store/breaks/moduleBreaks.js";
import FloatingButtons from "@/views/FloatingButtons.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export const BreakEditMixin = {
	name: "BreakEdit",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		BreakEditCron,
		FloatingButtons,
	},
	props: {
		dataBreak: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			breakObject: JSON.parse(JSON.stringify(this.dataBreak)),
			cronExpresion: "",
			activeNavItem: 0,
			maximize: false,
			durationProps: "12:00:00",
			showDateEditBreak: new Date(),
		};
	},
	created() {
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
	},
	mounted() {
		if (this.breakObject.hasOwnProperty("duration") && this.breakObject["duration"] !== null) {
			const [hours, minutes, seconds] = this.breakObject["duration"].split(":");
			this.hours = parseInt(hours);
			this.minutes = parseInt(minutes);
			this.seconds = parseInt(seconds);
		}
	},
	watch: {
		durationBreak(val) {
			this.durationProps = val;
			this.breakObject.duration = val;
		},
	},
	computed: {
		navbarTitle() {
			if (this.activeNavItem === 0) return this.$t("Crud.Update") + " " + this.$t("TimeWindow.Schedule");
			else return this.$t("VisitPoints.Add") + " " + this.$t("Vehicles.Vehicles");
		},
		validateForm() {
			return !this.errors.any();
		},
		vehicleIds() {
			return this.breakObject["vehicle_id"] && this.breakObject["vehicle_id"] !== null
				? this.breakObject["vehicle_id"]
				: [];
		},
		cronExpression() {
			return this.$store.state.moduleBreaks.cronExpression;
		},
		durationBreak() {
			return `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		maximizeCalendar(val) {
			this.maximize = val;
		},
		getCronExpresion(val) {
			this.cronExpresion = val;
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		update() {
			let params = {};
			this.breakObject["vehicle_id"] =
				this.$store.state.vehicle.assignedVehicles.length > 0
					? this.$store.state.vehicle.assignedVehicles.map(({id}) => id)
					: [];
			this.breakObject["cron"] = this.$store.state.moduleBreaks.cronExpression;
			this.breakObject["duration"] = `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
			params = {...this.breakObject};
			this.$store
				.dispatch("moduleBreaks/updateItem", {id: this.breakObject.id, params})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmBreakUpdate"),
						text: this.$t("TextConfirmBreakUpdate"),
					});
					this.$vs.loading.close();
					this.$router.push({name: "BreaksListView"});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					console.error(err);
				});
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.update();
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorFields.Title"),
						text: this.$t("ErrorFields.Text"),
					});
					this.$vs.loading.close();
				}
			});
		},
		getShowDate(val) {
			this.showDateEditBreak = val;
		},
		getEvent() {
			this.breakObject.duration = this.durationBreak;
			this.$refs.breakEditCron.getEvents(this.cronExpression);
		},
	},
};
